import { render, staticRenderFns } from "./ListadoProgramas.vue?vue&type=template&id=270cc6ce&"
import script from "./ListadoProgramas.vue?vue&type=script&lang=js&"
export * from "./ListadoProgramas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports